import {compareArray} from '../lib/Utils.js';
import {difference, intersection, clone, union} from "lodash";


// Difference Object
// Built by Model.js change tester & passed to views
// Views can do partial changes by id if desired
// As views aren't always immediately executed diff objects can be combined
//



export default function Difference(modelName, setName, oldOrder, newOrder)
{
    // TBD create set object and just pass it back...
    this.modelName = modelName;
    this.setName = setName;
    this.oldOrder = oldOrder ? clone(oldOrder) : [];
    this.newOrder = this.oldOrder;
    this.changed = [];
    this.removed = [];
    this.added = [];
    this.reordered = this.replaced = this.contentChanged = this.anythingChanged = this.collectionChanged = false;
    if (newOrder) this.setNewOrder(newOrder);
}

Difference.prototype =
{
    addChanged: function(change){
        this.changed.push(change);  //single value
        this.contentChanged = this.anythingChanged =  null;
    },
    setChanged: function(changes){
        this.changed = changes;  //array ?_clone
        this.contentChanged = this.anythingChanged =  null;
    },
    setNewOrder: function(newOrder) {
        this.newOrder=clone(newOrder);
        this.removed = this.added = null ;
        this.reordered = this.replaced = this.contentChanged = this.anythingChanged = this.collectionChanged = null;
    },

    getChanged: function(){
        return this.changed ;
    },
    getAdded: function()
    {
        if (this.added === null) {
            this.added = difference(this.newOrder,this.oldOrder) ;
        }
        return this.added;
    },
    getRemoved: function()
    {
        if (this.removed === null) {
            this.removed = difference(this.oldOrder,this.newOrder) ;
        }
        return this.removed;
    },
    getNewOrder: function() { //TBD ? return clones
        return this.newOrder;
    },
    getOldOrder: function() {
        return this.oldOrder;
    },

    isReordered: function()
    {
        if (this.reordered === null) {
            this.reordered = ! compareArray(this.oldOrder,this.newOrder, true);
        }
        return this.reordered;
    },
    isReplaced: function()  // nothing in the set the same
    {
        if (this.replaced === null) {
            this.replaced = intersection( this.oldOrder,this.newOrder).length === 0 &&
                (this.newOrder.length !== 0 || this.oldOrder.length !== 0) ;
        }
        return this.replaced;
    },
    isCollectionChanged: function()         //ignores order of set
    {
        if (this.collectionChanged === null) {
            this.collectionChanged =  ! compareArray(this.oldOrder,this.newOrder);
        }
        return this.collectionChanged;
    },
    isContentChanged: function()         //ignores order of set
    {
        if (this.contentChanged === null) {
            this.contentChanged = this.changed.length !== 0 || this.isCollectionChanged();
        }
        return this.contentChanged;
    },
    isAnythingChanged: function()
    {
        if (this.anythingChanged === null) {
            this.anythingChanged = this.changed.length !== 0 || this.isReordered();
        }
        return this.anythingChanged;
    },

    combine: function(previous)
    {
        if (!previous) {
            return this;
        }

        const both = new Difference(this.modelName, this.setName, previous.getOldOrder());
        both.setNewOrder(this.getNewOrder());
        both.setChanged( intersection(
            union( this.getChanged(), previous.getChanged(), previous.getRemoved() ) ,
            this.getNewOrder(),
            previous.getOldOrder() )
        );
        return both;
    }
};